import querystring from "querystring";
import { User } from "/src/models";
import Role from "../../models/Role";
import config from "/src/config";

export function loginSuccessRedirectUrl(user: User) {
  if (user.roles.some((v: string) => v === Role.ROLE_ADMIN) && config.APP_ENV_IS_ONBOARDING_ENV) {
    return "/admin";
  }
  if (user.roles.some((v: string) => v === Role.ROLE_ORG_ADMIN)) {
    return "/dashboard";
  }
  if (user.roles.some((v: string) => v === Role.ROLE_ADMIN || v === Role.ROLE_USER)) {
    return "/";
  }
  if (user.roles.some((v: string) => v === Role.ROLE_MOBILE_USER)) {
    return "/person/list";
  }

  return "/";
}

/**
 * Custom post-login `redirectUrl` query values that must not be followed.
 * Following `/user/*` or the legacy `/login` alias re-enters the auth layout
 * while a token is present and causes a TanStack Router redirect loop
 * ("Maximum update depth exceeded").
 */
export function isUnsafePostLoginRedirect(redirectUrl: string): boolean {
  const path = redirectUrl.split("?")[0] || "";
  return (
    path === "" ||
    path === "/" ||
    path === "/dashboard" ||
    path === "/login" ||
    path === "/user" ||
    path.startsWith("/user/")
  );
}

export function redirectUrlFromSearch(search: string = ""): string | undefined {
  const raw = search.startsWith("?") ? search.slice(1) : search.replace(/^\?/, "");
  if (!raw) {
    return undefined;
  }
  const parsed = querystring.parse(raw).redirectUrl;
  const redirectUrl = Array.isArray(parsed) ? parsed[0] : parsed;
  return typeof redirectUrl === "string" && redirectUrl.length > 0 ? redirectUrl : undefined;
}

/** Where an already-authenticated session on `/user/*` should go. */
export function resolveAuthenticatedUserRedirect(
  user: User,
  search: string = typeof window !== "undefined" ? window.location.search : "",
): string {
  if (user.redirection) {
    if (user.roles?.some((v: string) => v === "ROLE_ADMIN") && config.APP_ENV_IS_ONBOARDING_ENV) {
      return "/admin";
    }
    if (user.roles?.some((v: string) => v === "ROLE_ORG_ADMIN")) {
      return "/dashboard";
    }
    return "/";
  }

  const redirectUrl = redirectUrlFromSearch(search);
  if (redirectUrl && !isUnsafePostLoginRedirect(redirectUrl)) {
    return redirectUrl;
  }

  return loginSuccessRedirectUrl(user);
}
